import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllDocumentTypes extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    gender:[],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getAllDocumentTypes({
          ...params,
          regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }


  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateDocumentType(values)
        } else {
            x = await Request.addDocumentType(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab:'0'
          })
          notification.success({
            message: this.state.id
              ? `Document Type Updated Successfully`
              : 'Document Type Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              documentTitle: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteDocumentType = async(data)=>{
    this.setState({loading:true})
    await Request.deleteDocumentType(data)
    this.setState({loading:false})
    this.table.current.reload();
    notification.success({
        message: 'Deleted Successfully',
        duration: 20,
        key: `${data._id}-close`
      })
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }


  setDocumentTypeData(documentTypeId) {
    if(documentTypeId) {
        Request.getDocumentTypeById({id:documentTypeId}).then(({doc,error,msg})=>{
            if(!error && doc) {
                this.setState({
                    id:doc._id,
                    activeTab:'1'
                })
                this.props.form.setFieldsValue({
                    documentTitle:doc.documentTitle,
                })
            }else {
                notification.error({
                    message:'Error Getting Data',
                    description:msg
                })
            }
        })
    }
  }

  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }


  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        {
            label:"Title",
            key:"documentTitle",
            required:true
        }
      ]
    };

    const columns = [
      {
        title: 'Title',
        key: 'documentTitle',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId && record.businessId !== "1001"?
          <React.Fragment>
            <RightsWrapper myRight={'documentTypes.edit'}>
              <Tooltip title="Edit Document Type">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setDocumentTypeData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'documentTypes.delete'}>
              <Tooltip title="Delete Gender">
                <Popconfirm
                  title="Are you sure delete this Document Type?"
                  onConfirm={() => {
                    this.deleteDocumentType({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
          :null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Document Type Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Document Types`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Document Type'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllDocumentTypes
